import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import ACF from "@/pages/ACF";
import Precontrattuale from "@/pages/Precontrattuale";
import Sostenibilita from "@/pages/Sostenibilita";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookie" element={<CookiePolicy />} />
          <Route path="/acf" element={<ACF />} />
          <Route path="/precontrattuale" element={<Precontrattuale />} />
          <Route path="/sostenibilita" element={<Sostenibilita />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
